var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLungs = function SvgLungs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4H13V10C13 10.7453 13.4077 11.3954 14.0122 11.7394C14.3588 -3.48461 22 6.07239 22 20.4281C20.8839 20.0622 17.3345 18.7093 15.3593 17.9513C14.7035 17.6996 14 16.6732 14 15.9707V14.5759C13.4451 13.9265 12.7226 13.3 12 13.3C11.2774 13.3 10.5549 13.9265 10 14.5759V15.9707C10 16.6732 9.29654 17.6996 8.64067 17.9513C6.66554 18.7093 3.11613 20.0622 2 20.4281C2 6.07239 9.64125 -3.48461 9.98784 11.7394C10.5923 11.3954 11 10.7453 11 10V4Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLungs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lungs.7dc054da.svg";
export { ForwardRef as ReactComponent };